import ServiceBase from "base/baseService"

export default class EscolaridadeService extends ServiceBase {

    title = "Escolaridade"
    pluralTitle = "Escolaridades"
    url = '/cadastro/pessoa/escolaridade'
    frontUrl = '/cadastro/pessoa/escolaridade'
    frontUrlList = '/cadastro/pessoa/escolaridadelist'
    primaryKey = 'codigo_esco'

    postDTO(data = {}) {

        return {
            ...data,
        }

    }
    prepareToFront(data = {}) {
        return {
            ...data,
        }
    }

    static async list(qs = '') {

        return super.list(qs).then((response) => {
            return response
        })
    }

    // Get show
    async getById({ id = null }) {

        return super.getById({ id }).then((response) => {
            // response.data = this.prepareToFront(response.data)
            console.log(response)
            return response
        }).catch((error) => {
            console.log("Erro (service): ", error)
            return error
        })

    }

}

